import { MousePointerClick, CreditCard, Headset, Rocket } from "lucide-react";
import { SectionHeading } from "@/components/site/ui";

const STEPS = [
    { icon: MousePointerClick, title: "Choose Your Service", body: "Select exactly what your business needs." },
    { icon: CreditCard, title: "Checkout", body: "Complete your order or enquiry securely." },
    { icon: Headset, title: "Talk to Our BDE", body: "A Sudigi Business Development Executive contacts you to understand your exact requirements." },
    { icon: Rocket, title: "Execution Begins", body: "Our team starts executing your selected digital growth service." },
];

export function HowItWorksSection() {
    return (
        <section className="bg-teal-950 py-20 grain" data-testid="how-it-works">
            <div className="container-x">
                <div className="mb-14 text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="Process" title="From Click to Growth in 4 Simple Steps" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 relative">
                    <div className="hidden md:block absolute top-8 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />
                    {STEPS.map((s, i) => (
                        <div key={s.title} className="relative text-center" data-testid={`step-${i + 1}`}>
                            <div className="mx-auto w-16 h-16 rounded-2xl bg-teal-700 border border-gold/40 flex items-center justify-center relative z-10">
                                <s.icon className="w-7 h-7 text-gold" />
                                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-gold text-teal-900 text-xs font-bold flex items-center justify-center">{i + 1}</span>
                            </div>
                            <h3 className="mt-4 font-bold text-cream">{s.title}</h3>
                            <p className="mt-2 text-sm text-cream-soft">{s.body}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
